import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/new-studio/icons/copy.svg")